import JournalgroupModel from '../journalgroup/journalgroup-model';
import OwnerModel from '../owner/owner-model';

export default class PaymenttypeModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    type: string;
    journalgroup: any;
    journalgroupCaption: string;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.type = datarow.type || 'cash';
        let journalgroup = datarow.journalgroup?.data? new JournalgroupModel(datarow.journalgroup?.data) : datarow.journalgroup;
        this.journalgroup = journalgroup?.id;
        this.journalgroupCaption = journalgroup?.name;

    } 

    public static endPoint: string = 'payment-types' 
    public static endPointFilterList = () => {
       const owner = OwnerModel.getOwner();
        return ( '?populate=*&sort=name&filters[owner]=' + owner);
    } 
    public static url: string = '/paymenttype';
    public static caption: string = 'Payment Type';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),         
        type: 'cash',
        journalgroup: null,
        journalgroupCaption: '',
  
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Account No' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Account No' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionType = [
        { name: 'cash', caption: 'Cash' },
        { name: 'banktransfer', caption: 'Bank Transfer' },
        { name: 'ewallet', caption: 'e-Wallet' },
    ]
}